import { api } from '../../api';

export interface StudentProfileData {
  _id: string;
  id?: string;
  name: string;
  email: string;
  phone?: string;
  createdAt?: string;
  profileImage?: string;
  [key: string]: any;
}

export class StudentProfileService {
  /**
   * Fetch the full student profile including createdAt, phone, profileImage
   */
  static async getProfile(): Promise<StudentProfileData> {
    const response = await api.get<
      StudentProfileData | { success?: boolean; data?: StudentProfileData }
    >('/student/profile');
    const payload = response.data as any;
    return payload?.data ?? payload;
  }

  /**
   * Upload a new profile image.
   * Data must be FormData with an 'image' field appending the File.
   */
  static async updateProfileImage(formData: FormData) {
    const response = await api.patch<
      | { message: string; profileImage: string; user: any }
      | { success?: boolean; data?: { message?: string; profileImage?: string; user?: any } }
    >('/student/profile/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    const payload = response.data as any;
    return payload?.user ?? payload?.data?.user ?? payload;
  }
}
